<form class="form-container" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
  <div class="inner-form-container">
    @if (errorInSendCode) {
      <p class="form-error">{{ errorInSendCode }}</p>
    }
    <app-custom-input
      [formControlName]="'userName'"
      [type]="'text'"
      [id]="'username'"
      [label]="LABEL_CONSTANT.USERNAME_EMAIL"
      [icon]="'user-input-icon.svg'"
      [placeholder]="PLACEHOLDER_CONSTANT.EMAIL_FORMAT"
      [required]="true"
      (textFieldValueChanges)="valueChange($event)"
    />
  </div>
  <app-button
    [type]="'submit'"
    [className]="'primary-form-button'"
    [label]="LABEL_CONSTANT.SEND_CODE"
    [disable]="!forgotPasswordForm.valid || !!errorInSendCode"
    [isLoader]="isSendCodeLoading"
  />
  <div class="nav-link">
    <a 
      role="button" 
      tabindex="0" 
      (click)="switchToLoginFlow()" 
      (keydown.enter)="switchToLoginFlow()" 
      (keydown.space)="switchToLoginFlow()"
    >
      {{ LABEL_CONSTANT.RETURN_TO_LOGIN }}
    </a>
  </div>
</form>
